module.exports = __webpack_public_path__ + "static/media/folder.dc3eab77.svg";